"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  box-shadow: -1px 0 1px 0 rgba(0, 0, 0, 0.06);\n  background: white;\n  top: ", "px;\n  bottom: 0;\n  width: 304px;\n  position: fixed;\n  overflow-y: auto;\n  overflow-x: hidden;\n  right: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// ToDo: this should come from context
var amountOfDetailBars = 1;

var RightContentDrawer = _styledComponents["default"].div(_templateObject(), amountOfDetailBars * 64);

var _default = RightContentDrawer;
exports["default"] = _default;